import React from 'react'
import Helmet from 'react-helmet'

import './layout.scss';
import '../../theme/theme.scss';
import Header from './header';
import Footer from './footer';

interface ILayoutProps {
  className?: string
  isIndex?: boolean
  pageName?: string
  children
}

const Layout: React.FunctionComponent<ILayoutProps> = props => {
  const { className, isIndex, children, pageName } = props;
  return <>
    <Helmet>
      <html lang="en" />
      <title>DIALOGUE{!!pageName ? ` | ${pageName}` : ''}</title>
      <meta property='description' content='Dialogue is a DIY club night and label based in Bristol with an open and inclusive ethos.' />
      <meta property='og:image' content={require('../../assets/brand/index-top-bg.jpg')} />
      <meta property='og:site_name' content='DIALOGUE' />
      <meta property='og:description' content='Dialogue is a DIY club night and label based in Bristol with an open and inclusive ethos.' />
      <link rel="apple-touch-icon" sizes="57x57" href="/apple-icon-57x57.png" />
      <link rel="apple-touch-icon" sizes="60x60" href="/apple-icon-60x60.png" />
      <link rel="apple-touch-icon" sizes="72x72" href="/apple-icon-72x72.png" />
      <link rel="apple-touch-icon" sizes="76x76" href="/apple-icon-76x76.png" />
      <link rel="apple-touch-icon" sizes="114x114" href="/apple-icon-114x114.png" />
      <link rel="apple-touch-icon" sizes="120x120" href="/apple-icon-120x120.png" />
      <link rel="apple-touch-icon" sizes="144x144" href="/apple-icon-144x144.png" />
      <link rel="apple-touch-icon" sizes="152x152" href="/apple-icon-152x152.png" />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-icon-180x180.png" />
      <link rel="icon" type="image/png" sizes="192x192" href="/android-icon-192x192.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="96x96" href="/favicon-96x96.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="manifest" href="/manifest.json" />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
      <meta name="theme-color" content="#ffffff"></meta>
    </Helmet>
    <Header isIndex={isIndex} />
    <main className={`page${className ? ` ${className}` : ''}`}>
      {children}
    </main>
    {/* <Footer /> */}
  </>
}

export default Layout
